import React, { useState, useEffect } from "react";
import {
  Box,
  Heading,
  Tabs,
  TabList,
  Tab,
  TabPanel,
  TabPanels,
  SimpleGrid,
  Stack,
  Spinner,
  Flex,
  Text,
} from "@chakra-ui/core";

import SearchBox from "../elements/SearchBox";
import Orders from "../common/Orders";
import { MdKeyboardArrowDown } from "react-icons/md";
// import { GET_MERCHANT_DETAILS } from "../../graphql/queries";
import { useCustomers } from "../../hooks/customer";

const OrdersGrid = ({ transactions, refetch }) => {
  const [orders, setOrders] = useState([]);
  const [paidOrders, setPaidOrders] = useState([]);
  const [canceledOrders, setCanceledOrders] = useState([]);
  const [refundedOrders, setRefundedOrders] = useState([]);
  const [pendingOrders, setPendingOrders] = useState([]);
  const [processingOrders, setProcessingOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  const [searchString, setSearchString, matches] = useCustomers();

  /**
   * filters out searched items
   *
   * @param {*} transactions
   * @param {*} matches
   * @returns
   */
  const processedData = (transactions, matches) => {
    let sortData = [];
    transactions.map((deal) => {
      return matches.forEach((match) => {
        if (
          deal.customer.firstName === match.firstName ||
          deal.customer.phone === match.phone
        ) {
          return sortData.push({
            ...deal,
            searched: true,
          });
        }
      });
    });
    if (matches.length > 0) {
      return sortData
        .filter((item) => item.searched === true)
        .sort((a, b) => b.createdAt - a.createdAt);
    }
    return transactions.sort((a, b) => b.createdAt - a.createdAt);
  };

  useEffect(() => {
    const sortedTransactions = processedData(transactions, matches).sort(
      (a, b) => b.createdAt - a.createdAt
    );

    const paidOrders = sortedTransactions.filter(
      (item) => item.status === "paid"
    );
    const canceledOrders = sortedTransactions.filter(
      (item) => item.status === "cancelled"
    );
    const refundedOrders = sortedTransactions.filter(
      (item) => item.status === "refunded"
    );
    const pendingOrders = sortedTransactions.filter(
      (item) => item.status === "pending"
    );

    const processingOrders = sortedTransactions.filter(
      (item) => item.status === "processing"
    );
    setPendingOrders(pendingOrders);
    setRefundedOrders(refundedOrders);
    setCanceledOrders(canceledOrders);
    setPaidOrders(paidOrders);
    setProcessingOrders(processingOrders);

    setOrders(sortedTransactions);
  }, [transactions, matches]);

  useEffect(() => {
    if (transactions) {
      const sortedTransactions = transactions.sort(
        (a, b) => b.createdAt - a.createdAt
      );

      setOrders(sortedTransactions);
      const paidOrders = sortedTransactions.filter(
        (item) => item.status === "paid"
      );
      const canceledOrders = sortedTransactions.filter(
        (item) => item.status === "canceled"
      );
      const refundedOrders = sortedTransactions.filter(
        (item) => item.status === "refunded"
      );
      const pendingOrders = sortedTransactions.filter(
        (item) => item.status === "pending"
      );

      const processingOrders = sortedTransactions.filter(
        (item) => item.status === "processing"
      );
      setPendingOrders(pendingOrders);
      setRefundedOrders(refundedOrders);
      setCanceledOrders(canceledOrders);
      setPaidOrders(paidOrders);
      setProcessingOrders(processingOrders);
      setLoading(false);
    }
  }, [transactions]);

  if (loading) {
    return (
      <Flex alignItems="center" height="50vh" justifyContent="center">
        <Spinner />
      </Flex>
    );
  }

  return (
    <Tabs variantColor="success">
      {/** Grid to memu/filter */}
      <Box overflowX="scroll">
        <TabList color="primary.400">
          <Tab fontSize={["12px", "14px", "14px", "14px"]}>ALL</Tab>
          <Tab fontSize={["12px", "14px", "14px", "14px"]}>PAID</Tab>
          <Tab fontSize={["12px", "14px", "14px", "14px"]}>PENDING</Tab>
          <Tab fontSize={["12px", "14px", "14px", "14px"]}>PROCESSING</Tab>
          <Tab fontSize={["12px", "14px", "14px", "14px"]}>CANCELLED</Tab>
          <Tab fontSize={["12px", "14px", "14px", "14px"]}>REFUNDED</Tab>
        </TabList>
      </Box>
      {/** Grid Search box */}
      <Box my="8">
        <SearchBox
          entity="Orders"
          searchString={searchString}
          setSearchString={setSearchString}
          matches={matches}
          widget={false}
        />
      </Box>

      {orders.length === 0 && !loading ? (
        <Flex align="center" justify="center" marginY="1rem">
          <Text fontSize="1rem" fontWeight="bold">
            No order found
          </Text>
        </Flex>
      ) : (
        <>
          <SimpleGrid
            columns={4}
            spacing={0}
            color="primary.400"
            fontSize={["xs", "sm", "sm", "sm"]}
          >
            <Box p="8px" height="auto" bg="warning.100" color="primary.500">
              <Stack isInline alignItems="flex-end">
                <Heading as="h5" size="sm">
                  Name
                </Heading>
                <Box as={MdKeyboardArrowDown} />
              </Stack>
            </Box>
            <Box p="8px" height="auto" bg="warning.100" color="primary.500">
              <Stack isInline alignItems="flex-end">
                <Heading as="h5" size="sm">
                  Amount
                </Heading>
                <Box as={MdKeyboardArrowDown} />
              </Stack>
            </Box>
            <Box p="8px" height="auto" bg="warning.100" color="primary.500">
              <Heading as="h5" size="sm">
                Status / Ref
              </Heading>
            </Box>
            <Box p="8px" height="auto" bg="warning.100" color="primary.500">
              <Heading as="h5" size="sm">
                Action
              </Heading>
            </Box>
          </SimpleGrid>
          <Box
            borderLeftWidth="1px"
            borderRightWidth="1px"
            borderColor="primary.100"
          >
            <TabPanels>
              {/** Panels section (filtered based on the Tab selection) */}

              <TabPanel>
                {/** Grid with all data */}
                <SimpleGrid
                  columns={4}
                  spacing={0}
                  color="primary.400"
                  fontSize={["xs", "sm", "sm", "sm"]}
                >
                  <Orders refetch={refetch} orders={orders} />
                </SimpleGrid>
              </TabPanel>
              <TabPanel p="16px">
                {/** Grid with PAID data */}
                <SimpleGrid
                  columns={4}
                  spacing={0}
                  color="primary.400"
                  fontSize={["12px", "14px", "14px", "14px"]}
                >
                  <Orders refetch={refetch} orders={paidOrders} />
                </SimpleGrid>
              </TabPanel>
              <TabPanel p="16px">
                {/** Grid with PENDING data */}
                <SimpleGrid
                  columns={4}
                  spacing={0}
                  color="primary.400"
                  fontSize={["12px", "14px", "14px", "14px"]}
                >
                  <Orders refetch={refetch} orders={pendingOrders} />
                </SimpleGrid>
              </TabPanel>

              <TabPanel p="16px">
                {/** Grid with PROCESSING data */}
                <SimpleGrid
                  columns={4}
                  spacing={0}
                  color="primary.400"
                  fontSize={["12px", "14px", "14px", "14px"]}
                >
                  <Orders refetch={refetch} orders={processingOrders} />
                </SimpleGrid>
              </TabPanel>

              <TabPanel p="16px">
                {/** Grid with CANCELLED data */}
                <SimpleGrid
                  columns={4}
                  spacing={0}
                  color="primary.400"
                  fontSize={["12px", "14px", "14px", "14px"]}
                >
                  <Orders refetch={refetch} orders={canceledOrders} />
                </SimpleGrid>
              </TabPanel>
              <TabPanel p="16px">
                {/** Grid with REFUNDED data */}
                <SimpleGrid
                  columns={4}
                  spacing={0}
                  color="primary.400"
                  fontSize={["12px", "14px", "14px", "14px"]}
                >
                  <Orders refetch={refetch} orders={refundedOrders} />
                </SimpleGrid>
              </TabPanel>
            </TabPanels>
          </Box>
        </>
      )}
      {/** Grid header/filter */}
    </Tabs>
  );
};

export default OrdersGrid;
